import { Components, Theme } from "@mui/material";

import { borderRadius } from "../../theme/borderRadius";

export const MuiSkeleton: Components<Theme>["MuiSkeleton"] = {
  styleOverrides: {
    rounded: {
      borderRadius: borderRadius.small,
    },
  },
};
